import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./methodology.css";

const Adaptation = process.env.REACT_APP_ADAPTATION;
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.js";

const Toolkit = () => {
  const [numPages, setNumPages] = useState(null);
  const [pagesToRender, setPagesToRender] = useState([]);

  const BATCH_SIZE = 5; // number of pages to render at once

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPagesToRender(
      Array.from({ length: Math.min(BATCH_SIZE, numPages) }, (_, i) => i + 1)
    );
  };

  useEffect(() => {
    if (!numPages) return;

    if (pagesToRender.length < numPages) {
      const timer = setTimeout(() => {
        const nextBatch = Array.from(
          { length: Math.min(BATCH_SIZE, numPages - pagesToRender.length) },
          (_, i) => pagesToRender.length + i + 1
        );
        setPagesToRender((prev) => [...prev, ...nextBatch]);
      }, 50); // small delay to prevent UI blocking
      return () => clearTimeout(timer);
    }
  }, [pagesToRender, numPages]);

  return (
    <div className="met_parent">
      <Document file={Adaptation} onLoadSuccess={onDocumentLoadSuccess}>
        {pagesToRender.map((pageNumber) => (
          <Page
            key={`page_${pageNumber}`}
            pageNumber={pageNumber}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            width={800} // adjust based on your container
          />
        ))}
      </Document>
    </div>
  );
};

export default Toolkit;
